module.exports = __webpack_public_path__ + "static/img/win7.6979b29a.png";